export default "__VITE_ASSET__B9uFnLi7__"